var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCardGrid',{attrs:{"layout":"1-1-1","skeletonsConfig":_vm.skeletonsConfig,"loading":_vm.loading}},[_c('Card',{attrs:{"headingLevel":4,"orientation":_vm.windowBreakpoint > 2 ? 'horizontal' : 'vertical',"thumbnailDisplay":"large","thumbnailAlign":"right","thumbnailSrc":null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }